import { EventAssociatedModel, EventShare } from '~/types/adamTypes';

export type UseAppEventShare = {
  clicked: () => void;
  openSendParentInfo: () => void;
  sentParentInfo: () => void;
  forcedOpenSendParentInfo: () => void;
};

export const useAppEventShare = (
  associatedModel: EventAssociatedModel,
  contentId: string,
  contentType: string,
  type?: string | null,
  discipline?: string,
  parent?: string,
  parentType?: string
): UseAppEventShare => {
  const { createEvent } = useAppEvent(associatedModel, contentId);

  const openSendParentInfo = async () => {
    await createEvent('openSendParentInfo', {
      contentType,
      type,
      discipline,
      parent,
      parentType,
    });
  };

  const sentParentInfo = async () => {
    await createEvent('sentParentInfo', {
      contentType,
      type,
      discipline,
      parent,
      parentType,
    });
  };

  const forcedOpenSendParentInfo = async () => {
    await createEvent('forcedOpenSendParentInfo', {
      contentType,
      type,
      discipline,
      parent,
      parentType,
    });
  };

  const clicked = async () => {
    await createEvent(EventShare.ShareClicked, {
      contentType,
      type,
      discipline,
      parent,
      parentType,
    });
  };
  return {
    clicked,
    openSendParentInfo,
    sentParentInfo,
    forcedOpenSendParentInfo,
  };
};
